import smoothScroll from './smooth-scroll-connect';

// //Connect Testimonials Carousel
// if (document.getElementById('connect-testimonials-carousel')) {
//     document.addEventListener('DOMContentLoaded', function () {
//         import('@splidejs/splide').then((Splide) => {
//             new Splide.default('#connect-testimonials-carousel', {
//                 type: 'fade',
//                 autoplay: true,
//                 pagination: false,
//             }).mount();
//         });
//     });
// }

//Page Navigation
if (document.getElementById('page-navigation')) {
    smoothScroll('navbar', 'service-menu-link');
}


// contact sales form
(function () {
    const contactSalesForm = document.getElementById('contactSalesForm');
    if (contactSalesForm) {
        contactSalesForm.addEventListener('submit', function (e) {
            e.preventDefault();
            const name = this.elements['name'].value;
            const phone = this.elements['phone'].value;
            const email = this.elements['email'].value;
            const recaptcha = this.elements['recaptcha'].value;
            const formMessage = document.querySelector('.form-message');
            formMessage.style.display = 'none';
            formMessage.classList.remove('error');
            axios
                .post('/api/authland-connect', {
                    name,
                    phone,
                    email,
                    recaptcha,
                })
                .then((response) => {
                    // TODO Add a GA event
                    formMessage.innerText = formMessage.dataset.success;
                })
                .catch((err) => {
                    const { data } = err.response;
                    formMessage.innerText = data?.message ? data.message : formMessage.dataset.error;
                    formMessage.classList.add('error');
                })
                .finally(() => (formMessage.style.display = 'block'));
        });
    }
})();

//Scroll to contact form on connect landing page
(function () {
    document.querySelectorAll('a[href^="#contact"]').forEach((anchor) => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const navbarElement = document.getElementById('navbar');

                if (navbarElement) {
                    // Get the computed height of the navbar
                    const navbarHeight = navbarElement.offsetHeight;
                    // Calculate the offset from the top of the page to the target element
                    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                        top: targetPosition - navbarHeight,
                        behavior: 'smooth',
                    });
                }
            }
        });
    });
})();

/*Authland Connect Landing Page Fade In Effect*/
function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
        }
    });
}

const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
};

const intersectionObserver = new IntersectionObserver(handleIntersection, observerOptions);
const elements = document.querySelectorAll('.animate-on-scroll');

elements.forEach((el) => {
    intersectionObserver.observe(el);
});

// // Pricing Carousel
// if (document.getElementById('connect-pricing-carousel')) {
//     document.addEventListener('DOMContentLoaded', function () {
//         import('@splidejs/splide').then((Splide) => {
//             new Splide.default("#connect-pricing-carousel", {
//                 type: 'slide',
//                 pagination: false,
//                 drag: false,
//                 perPage: 4,
//                 perMove: 1,
//                 autoplay: 'false',
//                 arrowPath:
//                     'M30.1708 18.6167C30.1795 18.6248 30.1881 18.633 30.1967 18.6411C31.2678 19.6677 31.2678 21.3323 30.1967 22.3589L14.6824 37.23C13.6114 38.2567 11.8748 38.2567 10.8038 37.23C9.73277 36.2034 9.73277 34.5389 10.8038 33.5123L24.3785 20.5003L10.8033 7.48767C9.73224 6.4611 9.73224 4.79676 10.8033 3.76993C11.8743 2.74336 13.6108 2.74336 14.6819 3.76993L30.1708 18.6167Z',
//                 classes: {
//                     arrows: 'splide-custom-arrow',
//                 },
//                 breakpoints: {
//                     1024: {
//                         perPage: 2,
//                     },
//                     640: {
//                         perPage: 1,
//                     },
//                 },
//             }).mount();
//         });
//     });
// }

document.addEventListener('DOMContentLoaded', function() {
    // Define the pricing tiers
    const pricingTiers = {
        // 8% commission
        "1": {
            monthly: [
                { max: 30, price: 10.00 },
                { max: 40, price: 11.00 },
                { max: 50, price: 12.00 },
                { max: 60, price: 13.00 },
                { max: 70, price: 14.00 },
                { max: 80, price: 15.00 },
                { max: 90, price: 16.00 },
                { max: 100, price: 17.00 },
                { max: 110, price: 18.00 },
                { max: 119, price: 19.00 }
            ],
            yearly: [
                { max: 30, price: 102.00 },
                { max: 40, price: 112.20 },
                { max: 50, price: 122.40 },
                { max: 60, price: 132.60 },
                { max: 70, price: 142.80 },
                { max: 80, price: 153.00 },
                { max: 90, price: 163.20 },
                { max: 100, price: 173.40 },
                { max: 110, price: 183.60 },
                { max: 119, price: 193.80 }
            ]
        },
        // 12% commission
        "2": {
            monthly: [
                { max: 30, price: 15.00 },
                { max: 40, price: 16.50 },
                { max: 50, price: 18.00 },
                { max: 60, price: 19.50 },
                { max: 70, price: 21.00 },
                { max: 80, price: 22.50 },
                { max: 90, price: 24.00 },
                { max: 100, price: 25.50 },
                { max: 110, price: 27.00 },
                { max: 119, price: 28.50 }
            ],
            yearly: [
                { max: 30, price: 153.00 },
                { max: 40, price: 168.30 },
                { max: 50, price: 183.60 },
                { max: 60, price: 198.90 },
                { max: 70, price: 214.20 },
                { max: 80, price: 229.50 },
                { max: 90, price: 244.80 },
                { max: 100, price: 260.10 },
                { max: 110, price: 275.40 },
                { max: 119, price: 290.70 }
            ]
        }
    };

    // Find all pricing cards on the page
    const pricingCards = document.querySelectorAll('.pricing-card');

    // Only proceed if we found pricing cards
    if (pricingCards && pricingCards.length > 0) {
        // Initialize each card
        pricingCards.forEach(card => {
            if (card.dataset.card && pricingTiers[card.dataset.card]) {
                initializePricingCard(card, pricingTiers[card.dataset.card]);
            }
        });
    }

    // Function to initialize a pricing card
    function initializePricingCard(card, tiers) {
        // Get elements within this specific card
        const slider = card.querySelector('.units-slider');
        const priceElement = card.querySelector('.card-price');
        const currentUnitsElement = card.querySelector('.current-units');
        const monthlyPlanRadio = card.querySelector('.monthly-plan');
        const yearlyPlanRadio = card.querySelector('.yearly-plan');
        const monthlyLabel = card.querySelector('label[for^="monthly-plan-"]');
        const yearlyLabel = card.querySelector('label[for^="yearly-plan-"]');

        // Make sure all required elements exist
        if (!slider || !priceElement || !currentUnitsElement ||
            !monthlyPlanRadio || !yearlyPlanRadio || !monthlyLabel || !yearlyLabel) {
            return;
        }

        // Add active class styles to labels
        function updateLabelStyles() {
            if (monthlyPlanRadio.checked) {
                monthlyLabel.classList.add('tw-font-bold', 'tw-text-dark-green');
                monthlyLabel.classList.remove('tw-text-dark-grey');
                yearlyLabel.classList.remove('tw-font-bold', 'tw-text-dark-green');
                yearlyLabel.classList.add('tw-text-dark-grey');
            } else {
                yearlyLabel.classList.add('tw-font-bold', 'tw-text-dark-green');
                yearlyLabel.classList.remove('tw-text-dark-grey');
                monthlyLabel.classList.remove('tw-font-bold', 'tw-text-dark-green');
                monthlyLabel.classList.add('tw-text-dark-grey');
            }
        }

        // Function to update the price based on units and billing cycle
        function updatePrice() {
            const units = parseInt(slider.value);

            // Update the current units display
            currentUnitsElement.textContent = units;

            // Determine which pricing cycle is selected
            const cycle = monthlyPlanRadio.checked ? 'monthly' : 'yearly';

            // Find the appropriate price tier
            let price = 0;
            for (const tier of tiers[cycle]) {
                if (units <= tier.max) {
                    price = tier.price;
                    break;
                }
            }

            // Update the price display
            priceElement.textContent = `€${price.toFixed(2)}`;

            // Update label styles to show which option is active
            updateLabelStyles();
        }

        // Add event listeners with null checks
        if (slider) slider.addEventListener('input', updatePrice);
        if (monthlyPlanRadio) monthlyPlanRadio.addEventListener('change', updatePrice);
        if (yearlyPlanRadio) yearlyPlanRadio.addEventListener('change', updatePrice);

        // Initialize the price and styles
        updatePrice();
        updateLabelStyles();
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Select all pricing cards
    const pricingCards = document.querySelectorAll('.pricing-card');

    pricingCards.forEach(card => {
      // Use a unique identifier from the card's data attribute
      const cardId = card.dataset.card || Math.random().toString(36).substr(2, 9);

      // Get the radio inputs within this card
      const monthlyRadio = card.querySelector('input[type="radio"][value="monthly"]');
      const yearlyRadio = card.querySelector('input[type="radio"][value="yearly"]');

      // Update the radio button names so they are unique per card
      monthlyRadio.name = 'billing-cycle-' + cardId;
      yearlyRadio.name = 'billing-cycle-' + cardId;

      // Update their IDs
      monthlyRadio.id = 'monthly-plan-' + cardId;
      yearlyRadio.id = 'yearly-plan-' + cardId;

      // Update label "for" attributes accordingly
      const monthlyLabel = card.querySelector('label[for="monthly-plan-1"]') || card.querySelector('label[for^="monthly-plan"]');
      const yearlyLabel = card.querySelector('label[for="yearly-plan-1"]') || card.querySelector('label[for^="yearly-plan"]');

      if (monthlyLabel) {
        monthlyLabel.setAttribute('for', monthlyRadio.id);
      }
      if (yearlyLabel) {
        yearlyLabel.setAttribute('for', yearlyRadio.id);
      }

      // Get the price element
      const priceElement = card.querySelector('.monthly-price');
      const monthlyPrice = parseFloat(priceElement.dataset.monthly);
      const yearlyPrice = parseFloat(priceElement.dataset.yearly);

      // Function to update price and label styles
      function updatePriceAndLabels() {
        if (monthlyRadio.checked) {
          priceElement.textContent = `€${monthlyPrice.toFixed(2)}`;
          monthlyLabel.classList.add('tw-font-bold', 'tw-text-green-800');
          monthlyLabel.classList.remove('tw-text-gray-500');
          yearlyLabel.classList.remove('tw-font-bold', 'tw-text-green-800');
          yearlyLabel.classList.add('tw-text-gray-500');
        } else if (yearlyRadio.checked) {
          priceElement.textContent = `€${yearlyPrice.toFixed(2)}`;
          yearlyLabel.classList.add('tw-font-bold', 'tw-text-green-800');
          yearlyLabel.classList.remove('tw-text-gray-500');
          monthlyLabel.classList.remove('tw-font-bold', 'tw-text-green-800');
          monthlyLabel.classList.add('tw-text-gray-500');
        }
      }

      // Attach event listeners
      monthlyRadio.addEventListener('change', updatePriceAndLabels);
      yearlyRadio.addEventListener('change', updatePriceAndLabels);

      // Initial setup
      updatePriceAndLabels();
    });
  });







